<nav class="breadcrumb-container">
  <ul class="breadcrumb">
    <li *ngFor="let breadcrumb of breadcrumbs; let last = last">
      <a *ngIf="!last" [routerLink]="breadcrumb.url">
        <i *ngIf="breadcrumb.icon" class="bi {{ breadcrumb.icon }} me-1"></i>
        {{ breadcrumb.label | translate }}
      </a>
      <span *ngIf="last">
        <i *ngIf="breadcrumb.icon" class="bi {{ breadcrumb.icon }} me-1"></i>
        {{ breadcrumb.label | translate}}
      </span>
    </li>
  </ul>
</nav>